import { AxiosResponse } from "axios";
import { _axios } from "../../../Base_Axios_Config/_axios";
import { I_CandidateGroups, I_Message } from "../../../../Models/interfaces";

export const getCandidateGroupsOfActivityHistoryByProcessInstanceIdService =
  (_data: {
    userToken: string;
    _data: {
      processInstanceId: string;
      historyId: string;
      page: string | number;
      size: string | number;
      search: string;
    };
  }): Promise<
    AxiosResponse<{
      error: number;
      messages: I_Message[];
      result: I_CandidateGroups;
    }>
  > => {
    return _axios.get(
      `/processes/running-instances/${_data._data.processInstanceId}/history/activities/${_data._data.historyId}/candidate-groups?search=${_data._data.search}&page=${_data._data.page}&size=${_data._data.size}`,
      {
        headers: {
          Authorization: `Bearer ${_data.userToken}`,
        },
      }
    );
  };
